import React from 'react'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { usePartnerAffiliateUserApproveMutation } from '~/graphql/types'
import { toast } from 'react-toastify'
import { IconCheck } from '@tabler/icons-react'

type ApproveModalProps = {
  open: boolean
  onClose: () => void
  userId: string
  onSuccess: () => void
}

export const ApproveModal: React.FC<ApproveModalProps> = ({ open, onClose, userId, onSuccess }) => {
  const [approveUser, { loading }] = usePartnerAffiliateUserApproveMutation({
    onCompleted() {
      toast.success('Preposto aprovado com sucesso!')
      onSuccess()
      onClose()
    },
    onError(err) {
      toast.error(err.message)
    }
  })

  const handleConfirm = () => {
    approveUser({ variables: { id: userId } })
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle>
        <Typography fontWeight={600} variant='h5'>Confirmar aprovação</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography color='text.secondary'>
          Tem certeza que deseja aprovar este preposto? Ele passará a ter acesso ao sistema.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ padding: '1rem 1.5rem' }}>
        <Button color='secondary' onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          color='primary'
          variant='contained'
          onClick={handleConfirm}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={18} color='inherit' /> : <IconCheck />}
        >
          Aprovar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
